<template>
    <div id="editor_left">
        <editorNoveloutline v-if="textoroutline == 0"></editorNoveloutline>
        <editorText v-if="textoroutline == 1"></editorText>
    </div>
</template>
<script>
import editorNoveloutline from '@/components/script/editor_noveloutline.vue' //编辑大纲
import editorText from '@/components/script/editor_text.vue' //编辑章纲，正文
export default {
    components: {
        editorNoveloutline, editorText
    },
    data() {
        return {
            textoroutline: 0,
        }
    },
    created() {
        let editItem = JSON.parse(sessionStorage.getItem('editItem'))
        if (editItem.editType) {
            this.textoroutline = 0
        } else if (editItem.editText) {
            this.textoroutline = 1
        }
    }
}
</script>

<style>
#editor_left {
    flex: 1;
    height: 100%;
    margin-right: 15px;
}
</style>